import { createTemplateFactory } from "@ember/template-factory";
export default createTemplateFactory(
/*
  <div class="select-kit-header-wrapper">
  {{component
    this.selectKit.options.selectedNameComponent
    tabindex=this.tabindex
    item=this.selectedContent
    selectKit=this.selectKit
    shouldDisplayClearableButton=this.shouldDisplayClearableButton
  }}

  {{d-icon this.caretIcon class="caret-icon"}}
</div>
*/
{
  "id": "+2QC9xZx",
  "block": "[[[10,0],[14,0,\"select-kit-header-wrapper\"],[12],[1,\"\\n  \"],[46,[30,0,[\"selectKit\",\"options\",\"selectedNameComponent\"]],null,[[\"tabindex\",\"item\",\"selectKit\",\"shouldDisplayClearableButton\"],[[30,0,[\"tabindex\"]],[30,0,[\"selectedContent\"]],[30,0,[\"selectKit\"]],[30,0,[\"shouldDisplayClearableButton\"]]]],null],[1,\"\\n\\n  \"],[1,[28,[35,1],[[30,0,[\"caretIcon\"]]],[[\"class\"],[\"caret-icon\"]]]],[1,\"\\n\"],[13]],[],false,[\"component\",\"d-icon\"]]",
  "moduleName": "/var/www/discourse/app/assets/javascripts/discourse/node_modules/.embroider/rewritten-packages/select-kit.dd9a86fe/node_modules/select-kit/components/tag-drop/tag-drop-header.hbs",
  "isStrictMode": false
});